module.exports = __webpack_public_path__ + "img/build.8fdc9cf9.png";